import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import BetItemHeaderTable from "./BetItemHeaderTable";

export default observer(function BetItemTableHead(props: {
	toggleDetails: () => void;
	isDetailsDisplayed?: boolean;
	isPrinting?: boolean;
	setIsPrinting: (value: boolean) => void;
}) {
	const { t } = useTranslation("mybets");

	return (
		<thead className="table--bets__head">
			<tr className="table--bets__head__row">
				<th className="u-padd--reset" colSpan={8}>
					<BetItemHeaderTable
						toggleDetails={props.toggleDetails}
						isDetailsDisplayed={props.isDetailsDisplayed}
						isPrinting={props.isPrinting}
						setIsPrinting={props.setIsPrinting}
					/>
				</th>
			</tr>
			<tr className="table--bets__subhead">
				<th className="table--bets__ts table--bets__ts--combi">
					&nbsp;
				</th>
				<th className="table--bets__ts table--bets__ts--event">
					{t<string>("ITEM.EVENT_NAME_COLUMN")}
				</th>
				<th className="table--bets__ts table--bets__ts--bank">
					&nbsp;
				</th>
				<th className="table--bets__ts table--bets__ts--bet-type">
					{t<string>("ITEM.TIP_NAME_COLUMN")}
				</th>
				<th className="table--bets__ts table--bets__ts--odds">
					{t<string>("ITEM.QUOTA_COLUMN")}
				</th>
				<th className="table--bets__ts table--bets__ts--results">
					{t<string>("ITEM.RESULT_COLUMN")}
				</th>
				<th className="table--bets__ts table--bets__ts--icon">
					&nbsp;
				</th>
			</tr>
		</thead>
	);
});
